import { Picture, matchesKeyForVtp } from '@oneaudi/vtp-shared';

export interface PictureGroups {
  [key: string]: Picture[];
}

export const PICTURE_TYPE_VTP = 'vtp';
export const PICTURE_TYPE_RENDER = 'render';
export const PICTURE_TYPE_PHOTO = 'photo';

export const filterImages = (
  dealerPhotoImages: any[],
  renderImages: any[],
  fallbackImage: any[],
  hideRenderImages: boolean,
  isNewCarStage: boolean
) => {
  const filteredImages: any[] = [];

  if (!hideRenderImages) {
    if (dealerPhotoImages?.length && renderImages?.length) {
      filteredImages.push(...dealerPhotoImages, ...renderImages);
    } else if (dealerPhotoImages?.length && !renderImages?.length && !isNewCarStage) {
      filteredImages.push(...dealerPhotoImages);
    } else if (renderImages?.length) {
      filteredImages.push(...renderImages);
    } else if (fallbackImage !== undefined) {
      filteredImages.push(...fallbackImage);
    }
  } else if (hideRenderImages && dealerPhotoImages?.length && !isNewCarStage) {
    filteredImages.push(...dealerPhotoImages);
  } else if (fallbackImage !== undefined) {
    filteredImages.push(...fallbackImage);
  }
  return filteredImages;
};

export const getFilteredPictureByGroup = (
  isNewCarStage: boolean,
  windowWidth: number,
  filteredImages: any[]
) => {
  const pictureGroups: PictureGroups = {};
  const pictures: any[] = [];
  const hasFallbackImg = filteredImages?.some((pics) => pics.type.includes('fallback'));
  const images = isNewCarStage
    ? filteredImages.filter((image) => !image.type?.startsWith(PICTURE_TYPE_PHOTO))
    : filteredImages;

  if (hasFallbackImg || !images) {
    images.forEach((picture) => {
      const groupKey = picture.key.split('_')[1];
      pictureGroups[groupKey] = pictureGroups[groupKey] || [];
      pictureGroups[groupKey].push(picture);
    });

    Object.keys(pictureGroups).forEach((groupKey) => {
      if (groupKey === '4x3') {
        pictures.push(pictureGroups[groupKey][0]);
      }
    });

    return [pictures];
  }

  // (pics) => pics.key.includes('16x5') || pics.key.includes('4x3') || pics.key.includes('16x96')
  const hasVtp4x3m1c = images.some((image) => image.key?.startsWith('vtp4x3m1c'));

  images.forEach((image) => {
    if (image.type?.startsWith(PICTURE_TYPE_RENDER)) {
      if (matchesKeyForVtp(image.key, hasVtp4x3m1c)) {
        pictures.push(image);
      }
    } else if (image.type?.startsWith(PICTURE_TYPE_PHOTO)) {
      pictures.push(image);
    }
  });
  return [pictures];
};
